import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative pt-16 w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20atmosphere%20with%20warm%20crimson%20and%20amber%20lighting%2C%20abstract%20geometric%20patterns%20suggesting%20hidden%20truths%20and%20secrets%2C%20newspaper%20texture%20overlay%2C%20mysterious%20and%20investigative%20mood%2C%20cinematic%20composition%20with%20deep%20shadows%2C%20high%20contrast%20chiaroscuro%2C%20no%20blue%20or%20purple%20tones%2C%20editorial%20photography%20style&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料社区 - 独家爆料平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>
      </div>

      <div className="container-main relative z-10 w-full">
        <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-500/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse-slow"></span>
            <span className="text-xs text-primary-200 font-medium">实时爆料 · 独家内幕</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
            真相从不缺席
            <br />
            <span className="text-primary-300">黑料社区为你揭开</span>
          </h1>

          <p className="mt-5 text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
            海量用户实名分享亲历黑料，覆盖娱乐、商业、职场等多领域。
            加入黑料社区，第一时间获取最新、最真实的内幕信息，与数百万用户共同见证真相。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <Link
              to="/category/entertainment"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              浏览最新爆料
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
            >
              我要爆料
              <i className="ri-pencil-line ml-2"></i>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10">
            {[
              { value: '2,000万+', label: '月活跃用户' },
              { value: '50万+', label: '实名爆料者' },
              { value: '10万+', label: '独家爆料' },
              { value: '99.7%', label: '真实性核验率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/50 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}